'use client';
import React, { useEffect, useMemo, useRef } from 'react';
import {CSSPlugin, gsap, TimelineLite} from "gsap";
import { usePathname } from 'next/navigation';
import {useInView } from 'framer-motion';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/dist/CSSRulePlugin';
import { useShowSetting } from '@/core/context/ShowSettingProvider';

gsap.registerPlugin(ScrollTrigger, CSSPlugin, CSSRulePlugin);

// eslint-disable-next-line react/display-name
const AboutSVG = React.memo(() => (

	<svg width="904" height="444" viewBox="0 0 904 444" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M822.269 193.23C875.524 269.171 903.994 359.721 903.778 452.473L753.203 452.326C753.218 443.551 752.852 434.771 752.103 425.986C747.503 373.333 729.142 322.814 698.862 279.494C668.582 236.174 627.447 201.575 579.579 179.165C485.335 135.226 370.876 141.341 279.518 205.198C239.821 232.903 207.398 269.78 185.003 312.697C162.608 355.614 150.902 403.302 150.881 451.711L0.301273 451.558C0.328177 433.683 1.41825 415.826 3.56571 398.08C18.4036 274.959 83.6079 158.427 193.255 81.7853C302.901 5.14382 434.733 -16.0491 555.466 12.3101C663.688 37.6052 758.724 102.049 822.269 193.23Z" fill="url(#paint0_linear_506_6584)" />
		<defs>
			<linearGradient id="paint0_linear_506_6584" x1="501.879" y1="73.3537" x2="690.077" y2="248.928" gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>
));


// eslint-disable-next-line react/display-name
const FooterSVG = React.memo(() => (
	<svg width="872" height="445" viewBox="0 0 872 445" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.1" d="M818.673 188.346C873.05 263.487 902.862 353.605 904.023 446.35L753.463 448.439C753.348 439.664 752.851 430.891 751.972 422.118C746.59 369.539 727.481 319.299 696.561 276.433C665.641 233.568 623.996 199.584 575.801 177.887C480.914 135.352 366.559 143.166 276.16 208.374C236.879 236.665 205.007 274.02 183.252 317.264C161.496 360.509 150.5 408.366 151.198 456.77L0.632845 458.853C0.394263 440.98 1.21899 423.109 3.10265 405.333C16.1103 282.006 79.5766 164.517 188.073 86.2557C296.569 7.99425 428.072 -15.1543 549.212 11.4085C657.798 35.0935 753.781 98.119 818.673 188.346Z" fill="url(#paint0_linear_509_7965)" />
		<defs>
			<linearGradient id="paint0_linear_509_7965" x1="496.538" y1="73.2413" x2="687.323" y2="246.001" gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>


));
// eslint-disable-next-line react/display-name
const ProductSVG = React.memo(() => (
	<svg width="496" height="438" viewBox="0 0 496 438" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.2" d="M81.871 244.071C28.7086 168.066 0.348849 77.4812 0.677669 -15.2708L151.252 -14.94C151.226 -6.16495 151.582 2.61552 152.32 11.4014C156.856 64.0599 175.156 114.601 205.383 157.957C235.61 201.314 276.703 235.963 324.543 258.431C418.735 302.485 533.201 296.51 624.636 232.763C664.366 205.107 696.835 168.269 719.282 125.38C741.729 82.4904 753.493 34.8164 753.573 -13.5922L904.152 -13.2562C904.104 4.61844 902.992 22.4744 900.823 40.2171C885.835 163.32 820.489 279.773 710.75 356.281C601.01 432.789 469.152 453.822 348.454 425.316C240.262 399.889 145.305 335.329 81.871 244.071Z" fill="url(#paint0_linear_507_7786)" />
		<defs>
			<linearGradient id="paint0_linear_507_7786" x1="402.115" y1="364.337" x2="214.131" y2="188.535" gradientUnits="userSpaceOnUse">
				<stop stopColor="#152637" stopOpacity="0" />
				<stop offset="1" stopColor="#152637" />
			</linearGradient>
		</defs>
	</svg>


));
// eslint-disable-next-line react/display-name
const CareerSVG = React.memo(() => (

	<svg width="496" height="438" viewBox="0 0 496 438" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.2" d="M81.871 244.071C28.7086 168.066 0.348849 77.4812 0.677669 -15.2708L151.252 -14.94C151.226 -6.16495 151.582 2.61552 152.32 11.4014C156.856 64.0599 175.156 114.601 205.383 157.957C235.61 201.314 276.703 235.963 324.543 258.431C418.735 302.485 533.201 296.51 624.636 232.763C664.366 205.107 696.835 168.269 719.282 125.38C741.729 82.4904 753.493 34.8164 753.573 -13.5922L904.152 -13.2562C904.104 4.61844 902.992 22.4744 900.823 40.2171C885.835 163.32 820.489 279.773 710.75 356.281C601.01 432.789 469.152 453.822 348.454 425.316C240.262 399.889 145.305 335.329 81.871 244.071Z" fill="url(#paint0_linear_512_12423)" />
		<defs>
			<linearGradient id="paint0_linear_512_12423" x1="402.115" y1="364.337" x2="214.131" y2="188.535" gradientUnits="userSpaceOnUse">
				<stop stopColor="#152637" stopOpacity="0" />
				<stop offset="1" stopColor="#152637" />
			</linearGradient>
		</defs>
	</svg>


));

// eslint-disable-next-line react/display-name
const DefaultSVG = React.memo(() => (


	<svg width="363" height="839" viewBox="0 0 363 839" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.2" d="M137.76 122.017C204.239 57.3366 289.092 14.7947 380.692 0.220748L404.552 148.893C395.887 150.277 387.278 152.039 378.724 154.178C327.478 167.114 280.533 193.294 242.595 230.093C204.656 266.892 177.058 313.017 162.566 363.845C134.214 463.89 158.498 575.91 236.104 655.918C269.783 690.69 311.357 716.82 357.296 732.087C403.234 747.353 452.178 751.306 499.971 743.609L523.827 892.288C506.177 895.111 488.374 896.882 470.513 897.591C346.601 902.571 221.164 856.779 128.022 760.754C34.8802 664.728 -7.05919 537.961 1.68921 414.252C9.4072 303.381 57.8757 199.286 137.76 122.017Z" fill="url(#paint0_linear_506_6655)" />
		<defs>
			<linearGradient id="paint0_linear_506_6655" x1="70.4951" y1="457.421" x2="213.82" y2="243.639" gradientUnits="userSpaceOnUse">
				<stop stopColor="white" stopOpacity="0" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
		</defs>
	</svg>


));

// eslint-disable-next-line react/display-name
const VersionSVG = React.memo(() => (
	<svg width="496" height="438" viewBox="0 0 496 438" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.2" d="M81.871 244.071C28.7086 168.066 0.348849 77.4812 0.677669 -15.2708L151.252 -14.94C151.226 -6.16495 151.582 2.61552 152.32 11.4014C156.856 64.0599 175.156 114.601 205.383 157.957C235.61 201.314 276.703 235.963 324.543 258.431C418.735 302.485 533.201 296.51 624.636 232.763C664.366 205.107 696.835 168.269 719.282 125.38C741.729 82.4904 753.493 34.8164 753.573 -13.5922L904.152 -13.2562C904.104 4.61844 902.992 22.4744 900.823 40.2171C885.835 163.32 820.489 279.773 710.75 356.281C601.01 432.789 469.152 453.822 348.454 425.316C240.262 399.889 145.305 335.329 81.871 244.071Z" fill="url(#paint0_linear_506_4697)" />
		<defs>
			<linearGradient id="paint0_linear_506_4697" x1="402.115" y1="364.337" x2="214.131" y2="188.535" gradientUnits="userSpaceOnUse">
				<stop stopColor="#152637" stopOpacity="0" />
				<stop offset="1" stopColor="#152637" />
			</linearGradient>
		</defs>
	</svg>

));


const RightSVGScroll = ({ version, career, about, footer, product }) => {
	const containerRef = useRef(null);
	const scroll = useShowSetting();

	// useEffect(() => {
	// 	if (!scroll?.scrollInstance) return;
	//
	// 	// Kill any existing ScrollTrigger instances first
	// 	ScrollTrigger.getAll().forEach(st => st.kill());
	//
	// 	const svgs = document?.querySelectorAll('.fixed-left');
	// 	const animations = [];
	//
	// 	svgs.forEach((svg, index) => {
	// 		// Create the animation
	// 		const animation = gsap.to(svg, {
	// 			rotation: 90,
	// 			ease: 'power1.out',
	// 			scrollTrigger: {
	// 				id: `svg-rotate-trigger-${index}`,
	// 				trigger: svg,
	// 				start: 'top bottom',
	// 				end: 'bottom top',
	// 				scrub: 0.2,
	// 				markers: false, // set to true for debugging
	// 				invalidateOnRefresh: true, // Recalculate on refresh
	// 				scroller: scroll?.scrollInstance?.el, // Using Locomotive Scroll's scroll element
	//
	// 			}
	// 		});
	// 		animations.push(animation);
	// 	});
	//
	// 	// Cleanup function
	// 	return () => {
	// 		animations.forEach(anim => {
	// 			if (anim.scrollTrigger) {
	// 				anim.scrollTrigger.kill();
	// 			}
	// 			anim.kill();
	// 		});
	// 	};
	// }, [scroll?.scrollInstance]);

	// Memoize the SVG selection logic
	const currentSVG = useMemo(() => {
		if (about) return <AboutSVG />;
		if (footer) return <FooterSVG />;
		if (product) return <ProductSVG />;
		if (career) return <CareerSVG />;
		if (version) return <VersionSVG />;
		return <DefaultSVG />;
	}, [about, footer, product, career, version]);

	return (
		<div  ref={containerRef} className="fixed-right" data-scroll data-scroll-repeat>
			{currentSVG}
		</div>
	);
};

export default RightSVGScroll;
